export class User {
    id: number;
    email: string;
    name: string;
    surname: string;
    password: string;
    avatar: string;
    language: string;
    token: string;
    tourStep: string;
    residence: string;
    postal_code: string;
    city: string;
    province: string;
    nationality: string;
    nif: string;


constructor(user: any) {
    this.id = user.id;
    this.email = user.email;
    this.surname = user.surname;
    this.token = user.token;
    this.password = user.password;
    this.name = user.name;
    this.avatar = user.avatar;
    this.language = user.language;
    this.residence = user.residence;
    this.postal_code = user.postal_code;
    this.city = user.city;
    this.province = user.province;
    this.nationality = user.nationality;
    this.nif = user.nif;
    this.tourStep = user.tourStep;

}
}
